import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehicleManufacturers'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehicleManufacturersStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehicleManufacturersStore",
			variables: false,
		})
	}
}

export async function load_VehicleManufacturers(params) {
  await initClient()

	const store = new VehicleManufacturersStore()

	await store.fetch(params)

	return {
		VehicleManufacturers: store,
	}
}
